<!--
    描述：支付结算入口页面
    Created by zl
-->
<template>
    <transition name="fade" mode="out-in">
        <!-- 用做缓存页面 -->
        <keep-alive :include="cachedViews">
            <router-view :key="key" />
        </keep-alive>
    </transition>
</template>

<script>
import { mapState } from 'vuex'
export default {
    name: 'Payment-settlement-home',
    data() {
        return {}
    },
    methods: {},
    computed: {
        ...mapState('tags', {
            cachedViews: state => state.cacheTags
        }),
        key() {
            // console.log(this.$route.name)
            return this.$route.name
        }
    }
}
</script>

<style scoped lang="less">
</style>

